// if user role is not known, default to read-only for safety
// if role name includes 'Read Only', the user is read-only
export const isReadOnly = (userInfo) => {
  if (!userInfo || !userInfo.role) {
    return true;
  }
  return userInfo.role.includes('Read Only');
}
